module.exports = __webpack_public_path__ + "static/media/stroke_erase.05c3d270.svg";